import React from "react";
import QuestionCard from "./question-card";

const ChoiceAddQuestionContent = () => {
  return (
    <div className="add-question-content">
      <EditeQuestionTop />
      <QuestionCard />
    </div>
  );
};
export default ChoiceAddQuestionContent;

const EditeQuestionTop = () => {
  return (
    <div className="add-question__top d-flex justify-content-between align-items-center w-100">
      <h5 className="size-h5"> أضافه سؤال</h5>
    </div>
  );
};
